import React from "react";
import { Link } from "react-router-dom";
import { Calendar, User } from "lucide-react";
import { formatPersianDate, getImageUrl } from "../lib/api";
import ImageWithSkeleton from "./ImageWithSkeleton";

export default function ArticleCard({ article, index = 0 }) {
  const coverUrl = getImageUrl(article.cover_image) ||
    "https://images.unsplash.com/photo-1556316828-60a9fe5343ae?w=1000";
  const thumbUrl = getImageUrl(article.cover_image, "thumb") || coverUrl;
  const dateStr = formatPersianDate(article.created_at);

  return (
    <Link
      to={`/articles/${article.slug}`}
      className="group block bg-white rounded-3xl overflow-hidden border border-stone-200 product-card-hover animate-fade-up"
      style={{ animationDelay: `${Math.min(index * 60, 400)}ms` }}
      data-testid={`article-card-${article.slug}`}
    >
      <div className="aspect-[16/10] overflow-hidden bg-cream-100 relative">
        <ImageWithSkeleton
          src={coverUrl}
          thumb={thumbUrl}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className="p-6">
        <div className="flex items-center gap-3 text-xs text-stone-500 mb-3">
          {article.author && (
            <span className="inline-flex items-center gap-1">
              <User className="w-3 h-3" /> {article.author}
            </span>
          )}
          {dateStr && (
            <span className="inline-flex items-center gap-1">
              <Calendar className="w-3 h-3" /> {dateStr}
            </span>
          )}
        </div>
        <h3 className="text-xl font-bold text-stone-900 mb-2 line-clamp-2 group-hover:text-amber-700 transition-colors">
          {article.title}
        </h3>
        <p className="text-sm text-stone-600 line-clamp-3 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="mt-4 text-sm text-amber-700 inline-flex items-center gap-1 group-hover:translate-x-1 transition-transform">
          مطالعه مقاله ←
        </div>
      </div>
    </Link>
  );
}
